import './SegmentationRow.scss';
import { ReactElement } from 'react';
import { IObjectListSegmentation } from './ObjectsList.container';
import { SegmentationsGroup } from './SegmentationsGroup';
import { SegmentationWithActions } from './SegmentationWithActions';

interface IMarkingToolRowProps {
  isReadOnly: boolean;
  segmentations: IObjectListSegmentation[];
  onShowHideAnnotationTypeClick: (annotationTypeId: string) => void;
  onShowHideSegmentationClick: (segmentation: IObjectListSegmentation) => void;
  onDeleteAnnotationTypeClick: (annotationTypeId: string) => void;
  onDeleteSegmentationClick: (segmentation: IObjectListSegmentation) => void;
  onSegmentationClick: (segmentation: IObjectListSegmentation) => Promise<void>;
}

export const SegmentationRow = ({
  isReadOnly,
  segmentations,
  onShowHideAnnotationTypeClick,
  onShowHideSegmentationClick,
  onDeleteAnnotationTypeClick,
  onDeleteSegmentationClick,
  onSegmentationClick,
}: IMarkingToolRowProps): ReactElement => {
  const onShowHideSegmentationWithActions = (segmentation: IObjectListSegmentation): void => {
    onShowHideAnnotationTypeClick(segmentation.feature.properties?.annotationTypeId);
  };

  return (
    <div className='segmentation-row'>
      {segmentations.length > 1 ? (
        <SegmentationsGroup
          isReadOnly={isReadOnly}
          segmentations={segmentations}
          onAnnotationTypeHiddenClick={onShowHideAnnotationTypeClick}
          onSegmentationHiddenClick={onShowHideSegmentationClick}
          onDeleteAnnotationTypeClick={onDeleteAnnotationTypeClick}
          onDeleteSegmentationClick={onDeleteSegmentationClick}
          onSegmentationClick={onSegmentationClick}
        />
      ) : (
        <SegmentationWithActions
          key={segmentations[0].id}
          isReadOnly={isReadOnly}
          objectListSegmentation={segmentations[0]}
          onShowHideClick={onShowHideSegmentationWithActions}
          onDeleteClick={onDeleteSegmentationClick}
          onClick={onSegmentationClick}
        />
      )}
    </div>
  );
};
